/**
 * Formata quantidade de lançamentos para exibição (ex.: 1,2 mi).
 * @param {number|string|null|undefined} valor
 */
export function formatarQuantidadeLancamentos(valor) {
  const n = Number(valor);
  if (!Number.isFinite(n)) return "—";
  if (n >= 1_000_000) {
    return `${(n / 1_000_000).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} mi`;
  }
  if (n >= 1_000) {
    return `${(n / 1_000).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} mil`;
  }
  return n.toLocaleString("pt-BR");
}
